import { Badge } from '@/components/ui/badge'
import { useI18n } from '@/lib/i18n'
import { cn } from '@/lib/utils'

export function RoomPaymentLabel({
  freeGame,
  paymentMode,
  className,
}: {
  freeGame: boolean | null | undefined
  paymentMode: 'split' | 'host' | null | undefined
  className?: string
}) {
  const { t } = useI18n()
  if (typeof freeGame !== 'boolean' || (!freeGame && !paymentMode))
    return null

  const mode = freeGame ? 'free' : paymentMode
  const labelKey = freeGame
    ? 'game.room.paymentFree'
    : paymentMode === 'host'
      ? 'game.room.paymentHost'
      : 'game.room.paymentSplit'

  return (
    <Badge
      variant="secondary"
      className={cn('max-w-full whitespace-normal text-start', className)}
      data-testid="room-payment-label"
      data-payment-mode={mode}
    >
      {t(labelKey)}
    </Badge>
  )
}
